import React, {FC, useEffect, useState} from 'react';
import styles from "../JobPage/JobPage.module.scss"
import {Job} from "../../dtos/dtos";
import {getJob, upsertJobDataforwardingEnabled} from "../../api";
import {useParams} from "react-router-dom";
import Alert from "react-bootstrap/Alert";
import DataEntriesManager from "../DeploymentPage/DataEntriesManager";
import {ButtonGroup, ToggleButton} from "react-bootstrap";


interface JobPageProps {
}

const JobPage: FC<JobPageProps> = (props) => {
    const [errorMsg, setErrorMsg] = useState<string>();
    const {jobId} = useParams();
    const [job, setJob] = useState<Job>();

    const dataForwardingOpts = [{
        name: "active",
        value: true
    },{
        name: "disabled",
        value: false
    }];

    useEffect(() => {
        if (jobId) {
            getJob(jobId).then(payload => {
                setJob(payload.data)
            });
        }
    },[jobId])

    const updateDataforwardingEnabled = (newValue: boolean | undefined) => {
        if (job && jobId && newValue !== undefined) {
            upsertJobDataforwardingEnabled(jobId, newValue).then(p => {
                if (p.data > 0)
                    setJob((j) => (
                        j === undefined ? undefined :
                        { ...j,
                            dataForwardingEnabled: newValue
                        }
                    ));
                else
                    setErrorMsg("Failed updating data forwarding setting")
            });
        }

    }
    return (
        <div className={styles.deploymentPage + ' box'}>
            <div>
                <h1>{job?.name}</h1>
                <h5>Deployment started
                    on {job?.createdTime ? new Date(job.createdTime).toLocaleString() : new Date().toLocaleString()}</h5>
                <h5>Current status: {job?.hasEnded ? <span className='ended'>Ended</span> :
                    <span className='running'>Running</span>}</h5>
            </div>
            <hr/>
            <div>
                <h4>Data Forwarding</h4>
                <div className={styles.forwardArea}>
                    <h5>Enabled:</h5>
                    <ButtonGroup className="d-inline-flex">
                        {
                            dataForwardingOpts.map((radio, idx) => (
                                <ToggleButton
                                    key={idx}
                                    id={`radio-${idx}`}
                                    type="radio"
                                    variant={radio.value ? 'outline-success' : 'outline-danger'}
                                    name="dataforwardOption"
                                    value={radio.name}
                                    checked={job?.dataForwardingEnabled === radio.value}
                                    onChange={(e) => updateDataforwardingEnabled(radio.value)}
                                >
                                    {radio.name}
                                </ToggleButton>
                            ))}
                    </ButtonGroup>
                </div>
            </div>
            <hr/>

            <DataEntriesManager jobId={jobId} job={job}/>
            {errorMsg && <Alert variant="danger">{errorMsg}</Alert>}
        </div>
    );
}

export default JobPage;
